(function () {
  'use strict';

  function setupMarquee(sectionEl) {
    var sliderWrap = sectionEl.querySelector('.reviews-section__slider-wrap');
    var track = sectionEl.querySelector('.reviews-section__track');
    if (!sliderWrap || !track) return null;

    var desktopQuery = window.matchMedia('(min-width: 750px)');
    var animationId = null;
    var copyWidth = 0;
    var position = 0;
    var speed = 0.6;

    function measureWidth() {
      var slides = track.querySelectorAll('.reviews-section__slide');
      if (!slides.length) return;

      var firstSlide = slides[0];
      var firstClone = null;

      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i].hasAttribute('data-clone')) {
          firstClone = slides[i];
          break;
        }
      }

      if (firstClone) {
        copyWidth = firstClone.offsetLeft - firstSlide.offsetLeft;
      } else {
        copyWidth = track.scrollWidth;
      }
    }

    function step() {
      if (!desktopQuery.matches || sliderWrap.classList.contains('is-filtered')) {
        stop(true);
        return;
      }

      if (!copyWidth) {
        measureWidth();
        if (!copyWidth) return;
      }

      position -= speed;

      if (Math.abs(position) >= copyWidth) {
        position += copyWidth;
      }

      track.style.transform = 'translateX(' + position + 'px)';
      animationId = requestAnimationFrame(step);
    }

    function start() {
      if (animationId || sliderWrap.classList.contains('is-filtered') || !desktopQuery.matches) return;
      animationId = requestAnimationFrame(step);
    }

    function stop(reset) {
      if (animationId) {
        cancelAnimationFrame(animationId);
        animationId = null;
      }

      if (reset) {
        position = 0;
        track.style.transform = 'translateX(0)';
      }
    }

    var resizeObserver = null;
    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(function () {
        copyWidth = 0;
        position = 0;
        if (!animationId) {
          track.style.transform = 'translateX(0)';
        }
      });
      resizeObserver.observe(track);
    }

    sliderWrap.addEventListener('mouseenter', function () {
      if (!desktopQuery.matches) return;
      stop(false);
    });

    sliderWrap.addEventListener('mouseleave', function () {
      if (!desktopQuery.matches) return;
      start();
    });

    var handleDesktopChange = function (event) {
      if (event.matches) {
        start();
      } else {
        stop(true);
      }
    };

    if (typeof desktopQuery.addEventListener === 'function') {
      desktopQuery.addEventListener('change', handleDesktopChange);
    } else if (typeof desktopQuery.addListener === 'function') {
      desktopQuery.addListener(handleDesktopChange);
    }

    start();

    return {
      resume: function () {
        copyWidth = 0;
        start();
      },
      pause: function () {
        stop(true);
      },
      teardown: function () {
        stop(true);
        if (resizeObserver) {
          resizeObserver.disconnect();
        }
      },
    };
  }

  function initReviews(sectionEl) {
    var sliderWrap = sectionEl.querySelector('.reviews-section__slider-wrap');
    var track = sectionEl.querySelector('.reviews-section__track');
    var filterBtns = sectionEl.querySelectorAll('.reviews-filter-btn');

    if (!track) return;

    var marquee = setupMarquee(sectionEl);

    if (!filterBtns.length) {
      return;
    }

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filter = this.dataset.filter;
        filterBtns.forEach(function (b) {
          b.classList.remove('is-active');
        });
        this.classList.add('is-active');

        if (filter === 'all') {
          // Resume marquee: remove filtered state, show all original cards
          sliderWrap.classList.remove('is-filtered');
          track.querySelectorAll('.review-card:not([data-clone])').forEach(function (card) {
            card.style.display = '';
          });
          track.querySelectorAll('.review-card[data-clone]').forEach(function (card) {
            card.style.display = '';
          });
          if (marquee) {
            marquee.resume();
          }
        } else {
          // Pause marquee: switch to static filtered view
          sliderWrap.classList.add('is-filtered');
          track.querySelectorAll('.review-card:not([data-clone])').forEach(function (card) {
            var tags = (card.dataset.tags || '').split(',').map(function (t) {
              return t.trim().toLowerCase();
            });
            card.style.display = tags.indexOf(filter.toLowerCase()) !== -1 ? '' : 'none';
          });
          track.querySelectorAll('.review-card[data-clone]').forEach(function (card) {
            card.style.display = 'none';
          });
          if (marquee) {
            marquee.pause();
          }
        }
      });
    });
  }

  function initScrollAnimations(sectionEl) {
    var animatedEls = sectionEl.querySelectorAll('[data-animate], [data-heading-reveal]');
    if (!animatedEls.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -100px 0px' },
    );

    animatedEls.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initSection(sectionEl) {
    initReviews(sectionEl);
    initScrollAnimations(sectionEl);
  }

  document.querySelectorAll('.reviews-section').forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.reviews-section');
    if (el) initSection(el);
  });
})();
